import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { Typography } from '../atoms';

/**
 * LoadingOverlay Molecule
 * A fullscreen loading overlay with optional message
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the overlay is visible
 * @param {string} props.message - Loading message to display
 * @param {Function} props.onClose - Function to call when backdrop is clicked
 * @param {number} props.opacity - Backdrop opacity (0-1)
 * @returns {React.ReactElement} LoadingOverlay component
 */
const LoadingOverlay = ({
  open = false,
  message = 'Loading...',
  onClose = null,
  opacity = 0.7,
}) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: (theme) => `rgba(0, 0, 0, ${opacity})`,
        flexDirection: 'column',
      }}
      open={open}
      onClick={onClose}
    >
      <CircularProgress color="primary" size={50} thickness={4} />
      
      {message && (
        <Typography 
          variant="h6" 
          component="div" 
          color="white" 
          sx={{ mt: 2 }}
        >
          {message}
        </Typography>
      )}
    </Backdrop>
  );
};

LoadingOverlay.propTypes = {
  open: PropTypes.bool,
  message: PropTypes.string,
  onClose: PropTypes.func,
  opacity: PropTypes.number
};

export default LoadingOverlay;